var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-3/4 mx-auto"},_vm._l((_vm.state.quote.pages),function(page){return _c('Page',{key:page.key,staticClass:"print-page min-h-screen overflow-hidden",attrs:{"page":page}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }